import { AddIcon, LockIcon, Search2Icon } from "@chakra-ui/icons";
import { Box, Stack, Text } from "@chakra-ui/layout";
import { Avatar } from "@chakra-ui/avatar";
import { useToast } from "@chakra-ui/toast";
import axios from "axios";
import { useEffect, useState } from "react";
import { getSender } from "../config/ChatLogics";
import ChatLoading from "./ChatLoading";
import GroupChatModal from "./miscellaneous/GroupChatModal";
import PublicGroupsModal from "./miscellaneous/PublicGroupsModal";
import { Button } from "@chakra-ui/react";
import { ChatState } from "../Context/ChatProvider";
import { PaletteIcon, BookmarkIcon } from "./ui/Icons";
import { IconButton, Tooltip } from "@chakra-ui/react";

const formatTime = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const now = new Date();
  if (d.toDateString() === now.toDateString()) {
    return d.toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" });
  }
  return d.toLocaleDateString("ru-RU", { day: "numeric", month: "short" });
};

const MyChats = ({ fetchAgain }) => {
  const [loggedUser, setLoggedUser] = useState();

  const { selectedChat, setSelectedChat, user, chats, setChats } = ChatState();

  const toast = useToast();

  const fetchChats = async () => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      };

      const { data } = await axios.get("/api/chat", config);
      setChats(data);
    } catch (error) {
      toast({
        title: "Ошибка",
        description: "Не удалось загрузить беседы",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-left",
      });
    }
  };

  useEffect(() => {
    setLoggedUser(JSON.parse(localStorage.getItem("userInfo")));
    fetchChats();
    // eslint-disable-next-line
  }, [fetchAgain]);

  return (
    <Box
      d={{ base: selectedChat ? "none" : "flex", md: "flex" }}
      flexDir="column"
      alignItems="center"
      p={4}
      bg="#FBF0D9"
      w={{ base: "100%", md: "31%" }}
      borderRadius="18px"
      border="1px solid"
      borderColor="#E4D2A6"
      boxShadow="0 14px 40px -18px rgba(36, 61, 39, 0.25)"
    >
      <Box
        pb={4}
        px={1}
        fontSize={{ base: "22px", md: "24px" }}
        fontFamily="'Prata', serif"
        color="#243D27"
        d="flex"
        w="100%"
        justifyContent="space-between"
        alignItems="center"
      >
        Беседы
        <Box d="flex">
          <Tooltip label="Избранное — заметки для себя" hasArrow>
            <IconButton
              aria-label="Избранное"
              icon={<BookmarkIcon size={14} />}
              size="sm"
              variant="outline"
              colorScheme="pine"
              borderRadius="10px"
              mr={2}
              _hover={{ bg: "#243D27", color: "#F2DFB6" }}
              onClick={async () => {
                try {
                  const cfg = {
                    headers: { Authorization: `Bearer ${user.token}` },
                  };
                  const { data } = await axios.post("/api/chat/saved", {}, cfg);
                  if (!chats.find((c) => c._id === data._id))
                    setChats([data, ...chats]);
                  setSelectedChat(data);
                } catch (e) {
                  toast({
                    title: "Не удалось открыть Избранное",
                    status: "error",
                    duration: 4000,
                    isClosable: true,
                    position: "bottom-left",
                  });
                }
              }}
            />
          </Tooltip>
          <PublicGroupsModal>
            <Button
              d="flex"
              size="sm"
              variant="outline"
              colorScheme="pine"
              borderRadius="10px"
              fontSize="14px"
              mr={2}
              rightIcon={<Search2Icon boxSize="10px" />}
              _hover={{
                bg: "#243D27",
                color: "#F2DFB6",
                transform: "translateY(-1px)",
              }}
            >
              Зайти
            </Button>
          </PublicGroupsModal>
          <GroupChatModal>
            <Button
              d="flex"
              size="sm"
              variant="outline"
              colorScheme="burgundy"
              borderRadius="10px"
              fontSize="14px"
              rightIcon={<AddIcon boxSize="9px" />}
              _hover={{
                bg: "#8D414B",
                color: "#FBF0D9",
                transform: "translateY(-1px)",
              }}
            >
              Новая
            </Button>
          </GroupChatModal>
        </Box>
      </Box>
      <Box
        d="flex"
        flexDir="column"
        w="100%"
        h="100%"
        borderRadius="12px"
        overflowY="hidden"
      >
        {chats ? (
          <Stack overflowY="scroll" spacing={2} pr={1}>
            {chats.map((chat) => {
              const isActive = selectedChat === chat;
              const other = chat.users?.find(
                (u) => u._id !== loggedUser?._id
              );
              return (
                <Box
                  onClick={() => setSelectedChat(chat)}
                  cursor="pointer"
                  d="flex"
                  alignItems="center"
                  bg={isActive ? "#8D414B" : "#F6E8C6"}
                  color={isActive ? "#FBF0D9" : "#243D27"}
                  border="1px solid"
                  borderColor={isActive ? "#8D414B" : "transparent"}
                  boxShadow={
                    isActive
                      ? "0 10px 24px -10px rgba(141, 65, 75, 0.55)"
                      : "none"
                  }
                  transition="all 0.16s ease"
                  _hover={
                    isActive
                      ? {}
                      : {
                          bg: "#FDF7E9",
                          transform: "translateY(-1px)",
                          boxShadow:
                            "0 8px 20px -12px rgba(36, 61, 39, 0.35)",
                        }
                  }
                  px={3}
                  py={2.5}
                  borderRadius="14px"
                  key={chat._id}
                >
                  {chat.isSaved ? (
                    <Box
                      w="38px"
                      h="38px"
                      minW="38px"
                      borderRadius="full"
                      bg={isActive ? "#FBF0D9" : "#8D414B"}
                      d="flex"
                      alignItems="center"
                      justifyContent="center"
                      mr={3}
                    >
                      <BookmarkIcon
                        size={16}
                        color={isActive ? "#8D414B" : "#F2DFB6"}
                      />
                    </Box>
                  ) : chat.isGroupChat ? (
                    <Box
                      w="38px"
                      h="38px"
                      minW="38px"
                      borderRadius="full"
                      bg={isActive ? "#FBF0D9" : "#243D27"}
                      d="flex"
                      alignItems="center"
                      justifyContent="center"
                      mr={3}
                    >
                      <PaletteIcon
                        size={20}
                        color={isActive ? "#8D414B" : "#F2DFB6"}
                      />
                    </Box>
                  ) : (
                    <Avatar
                      size="sm"
                      w="38px"
                      h="38px"
                      mr={3}
                      name={other?.name}
                      src={other?.pic}
                    />
                  )}
                  <Box flex="1" minW={0}>
                    <Box d="flex" justifyContent="space-between" alignItems="baseline">
                      <Text fontWeight={500} isTruncated>
                        {chat.isSaved
                          ? "Избранное"
                          : !chat.isGroupChat
                          ? getSender(loggedUser, chat.users)
                          : chat.chatName}
                        {chat.isGroupChat && chat.isPrivate && (
                          <LockIcon
                            boxSize="11px"
                            ml={1.5}
                            mb="2px"
                            opacity={0.55}
                          />
                        )}
                      </Text>
                      {chat.latestMessage && (
                        <Text
                          fontSize="11px"
                          opacity={0.65}
                          ml={2}
                          whiteSpace="nowrap"
                        >
                          {formatTime(chat.latestMessage.createdAt)}
                        </Text>
                      )}
                    </Box>
                    {chat.latestMessage && (
                      <Text fontSize="xs" opacity={0.75} isTruncated>
                        {chat.latestMessage.sender?.name}:{" "}
                        {chat.latestMessage.content || "вложение"}
                      </Text>
                    )}
                  </Box>
                </Box>
              );
            })}
          </Stack>
        ) : (
          <ChatLoading />
        )}
      </Box>
    </Box>
  );
};

export default MyChats;
